import { IconButton, Tooltip } from '@mui/material';

/**
 * Botão de ícone com tooltip padronizado — elimina o boilerplate Tooltip+IconButton
 * repetido em 23 arquivos com 60+ instâncias.
 *
 * @param {string}    title      - Texto do tooltip
 * @param {ReactNode} icon       - Ícone a exibir (ex: <EditIcon />)
 * @param {Function}  onClick    - Callback de clique
 * @param {string}    [color]    - Cor MUI do botão (default: 'default')
 * @param {string}    [size]     - Tamanho do botão (default: 'small')
 * @param {boolean}   [disabled] - Desabilitar botão
 * @param {Object}    [sx]       - sx extra passado ao IconButton
 * @param {*}         props      - demais props repassadas ao IconButton
 *
 * @example
 * <TooltipIconButton title="Editar" icon={<EditIcon />} color="primary" onClick={handleEdit} />
 * <TooltipIconButton title="Excluir" icon={<DeleteIcon />} color="error" onClick={handleDelete} />
 */
export default function TooltipIconButton({
  title,
  icon,
  onClick,
  color = 'default',
  size = 'small',
  disabled = false,
  sx,
  ...props
}) {
  return (
    <Tooltip title={title}>
      <span>
        {/* span necessário para que o Tooltip funcione com disabled=true */}
        <IconButton
          size={size}
          color={color}
          onClick={onClick}
          disabled={disabled}
          sx={sx}
          {...props}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
}
